<template>
  <q-dialog :model-value="modelValue" position="right" full-height @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="width:640px; max-width:92vw">
      <q-bar class="bg-teal-8 text-white">
        <q-icon name="receipt_long" size="18px" />
        <span class="q-ml-sm text-caption">Свод УСП</span>
        <q-space />
        <q-btn icon="close" flat dense round size="sm" v-close-popup />
      </q-bar>

      <div v-if="data.loading" class="q-pa-lg text-center">
        <q-spinner size="30px" color="teal" />
      </div>

      <q-scroll-area v-else style="height: calc(100vh - 50px)">
        <div class="q-px-sm q-pt-sm">
          <div class="text-caption text-grey-6">гуид: <span class="text-grey-8" style="word-break:break-all">{{ data.uspGuid }}</span></div>
        </div>

        <q-markup-table dense flat separator="cell" class="q-mt-sm">
          <thead>
            <tr style="background:#e0f2f1">
              <th class="text-left">Период</th>
              <th class="text-right">Сумма СМР</th>
              <th class="text-right">Сумма Материал</th>
              <th class="text-left">Контрагент</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, ri) in data.rows" :key="ri">
              <td class="text-left text-caption">{{ fmtDateRu(r.value_date) }}</td>
              <td class="text-right mono">{{ fmtNum(r.sum_smr) }}</td>
              <td class="text-right mono">{{ fmtNum(r.sum_materials) }}</td>
              <td class="text-left text-caption" style="max-width:200px; white-space:normal">{{ r.contractor_name || '—' }}</td>
            </tr>
            <tr v-if="!data.rows.length">
              <td colspan="4" class="text-center text-grey-5">Нет данных</td>
            </tr>
          </tbody>
        </q-markup-table>
      </q-scroll-area>
    </q-card>
  </q-dialog>
</template>

<script>
import { useFormatters } from '../composables/useFormatters';

export default {
  name: 'PpmUspGuidDetailDialog',
  props: {
    modelValue: Boolean,
    data: { type: Object, default: () => ({ show: false, loading: false, uspGuid: '', rows: [] }) },
  },
  emits: ['update:modelValue'],
  setup() {
    const { fmtNum, fmtDateRu } = useFormatters();
    return { fmtNum, fmtDateRu };
  },
};
</script>
